import React, { useState, useEffect } from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { Loader, Message } from 'semantic-ui-react';
import * as Yup from 'yup';

import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import { Container } from './styles';
import Table from '../../components/Table';
import Filter from './Filter/';

import { GET_ALL_RECORDS, GET_MALLS } from '../../services/graphql/queries';

const plateType = [
  { key: 'all', value: '', text: 'Todos' },
  { key: 'invalid', value: 'invalid', text: 'Inválido' },
  { key: 'valid', value: 'valid', text: 'Válido' },
  { key: 'black_list', value: 'black_list', text: 'Lista Negra' }
];

const columns = [
  { id: 'mall', label: 'Centro Comercial', minWidth: 120 },
  { id: 'license_plate', label: 'Patentes', minWidth: 50 },
  { id: 'camera_lpr_cat_id', label: 'Id Cámara', minWidth: 100 },
  { id: 'camera_name', label: 'Sentido', minWidth: 50 },
  { id: 'mall_access_name', label: 'Acceso', minWidth: 50 },
  { id: 'type_name', label: 'Tipo', minWidth: 80 },
  { id: 'datetime', label: 'Fecha de Captura', minWidth: 120 }
];

const schema = Yup.object().shape({
  plate: Yup.string().min(3),
  begin_datetime: Yup.date().required(),
  finish_datetime: Yup.date().required()
});

export default function LicensePlates() {
  const [mallsOptions, setMallsOptions] = useState([]);
  const [
    { begin_datetimeError, finish_datetimeError, plateError },
    setFormError
  ] = useState({
    begin_datetimeError: false,
    finish_datetimeError: false
  });
  const [filters, setFilters] = useState({
    begin_datetime: new Date(),
    finish_datetime: new Date()
  });

  const [getAllRecords, { loading, error, data }] = useLazyQuery(
    GET_ALL_RECORDS,
    {
      variables: {
        begin_datetime: filters.begin_datetime,
        finish_datetime: filters.finish_datetime,
        plate: filters.plate,
        mall_id: filters.mall_id,
        type: filters.type
      }
    }
  );

  const { data: fetchedMalls } = useQuery(GET_MALLS);

  useEffect(() => {
    if (fetchedMalls && fetchedMalls.getMalls) {
      const malls = fetchedMalls.getMalls.map(mall => ({
        key: mall.id,
        text: `${mall.name} - ${mall.code}`,
        value: mall.id,
        country_id: mall.country_id
      })).filter((data, index) => index !== 0);

      setMallsOptions(malls);
    }
  }, [fetchedMalls, filters]);

  async function handleFilterOnClick(
    plate,
    type,
    mall_id,
    begin_datetime,
    finish_datetime
  ) {
    try {
      setFormError({
        begin_datetimeError: false,
        finish_datetimeError: false,
        plate: false
      });

      await schema.validate(
        { begin_datetime, finish_datetime, plate },
        { abortEarly: false }
      );

      setFilters({ plate, type, mall_id, begin_datetime, finish_datetime });
      getAllRecords();
    } catch (err) {
      err.inner &&
        err.inner.map(error =>
          setFormError(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
    }
  }

  return (
    <Container>
      <FlexContainer>
        <FlexChildren>
          <Filter
            onClick={handleFilterOnClick}
            plateType={plateType}
            malls={mallsOptions}
            errors={{ begin_datetimeError, finish_datetimeError, plateError }}
          />
          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={
                data.getAllRecords
                  ? [
                      ...(data.getAllRecords.excluded || []),
                      ...(data.getAllRecords.notExcluded || []),
                      ...(data.getAllRecords.lprBlacklist || [])
                    ]
                  : []
              }
              columns={columns}
            />
          )}
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
